(function () {
    const badge = document.querySelector('[data-fc-id="minicart-quantity"]');
    if (!badge) return;

    function sync() {
        badge.hidden = (parseInt(badge.textContent, 10) || 0) === 0;
    }

    document.addEventListener('foxycart:ready', sync);
    document.addEventListener('foxycart:cart:updated', sync);
})();
